import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddLinkIcon from '@mui/icons-material/AddLink';
import { CreateCustomerAuthContext, initialStateStep4 } from '../Create';

const SearchResult = props => {
  const { destination, idName, setDestinationName, setDestinationState } = props;
  const {
    destinationAddress,
    destinationCity,
    destinationIdName,
    destinationName,
    destinationState,
  } = destination;

  const {
    info: { controlNumbers },
    setInfo,
  } = useContext(CreateCustomerAuthContext);

  // findControlNumber :: String -> ControlNumber
  const findControlNumber = R.propEq('idName', idName);

  // prettier-ignore
  // handleClick :: Destination -> [ControlNumber]
  const handleAdd = R.compose(
    () => setDestinationState({ id: '', name: '' }),
    () => setDestinationName(''),
    setInfo,
    R.curryN(2, R.compose(
      R.mergeLeft(initialStateStep4), 
      R.assoc('controlNumbers')
    )),
    R.update(
      R.findIndex(findControlNumber, controlNumbers), 
      R.__, 
      controlNumbers
    ),
    R.mergeRight(R.find(findControlNumber, controlNumbers))
  );

  return (
    <Box sx={{ columnGap: 1, display: 'grid', gridTemplateColumns: '1fr 2fr 48px' }}>
      <Typography variant="body2">{destinationIdName}</Typography>

      <Stack spacing={0.5} sx={{ gridColumn: '2 / 3' }}>
        <Typography variant="body2">{destinationName}</Typography>
        {destinationAddress && <Typography variant="body2">{destinationAddress}</Typography>}
        <Typography variant="body2">
          {destinationCity}, {destinationState}
        </Typography>
      </Stack>

      <Button
        onClick={() => handleAdd(destination)}
        sx={{
          '@media (hover:none)': {
            '&:hover': {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          },
          height: 32,
          minWidth: 48,
          mt: -1,
          pt: 0,
        }}
        variant="text"
      >
        <AddLinkIcon />
      </Button>
    </Box>
  );
};

SearchResult.propTypes = {
  destination: PropTypes.shape({
    destinationAddress: PropTypes.string,
    destinationCity: PropTypes.string,
    destinationIdName: PropTypes.string,
    destinationName: PropTypes.string,
    destinationState: PropTypes.string,
  }).isRequired,
  idName: PropTypes.string.isRequired,
  setDestinationName: PropTypes.func.isRequired,
  setDestinationState: PropTypes.func.isRequired,
};

export default SearchResult;
